import { NgModule } from '@angular/core';
import { InputV2Component } from './components/input-v2/input-v2.component';
import { CurrencyInputComponent } from './components/currency-input/currency-input.component';
import { TextareaV2Component } from './components/textarea-v2/textarea-v2.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCurrencyDirective } from 'ngx-currency';

const FORMS_COMPONENTS = [InputV2Component, CurrencyInputComponent, TextareaV2Component];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxCurrencyDirective],
  declarations: [FORMS_COMPONENTS],
  exports: [FORMS_COMPONENTS]
})
export class FormsV2Module {}
